import { t } from '../../../../locale';
import { FlowInterface } from '../flow-interface';
import { generateBuyLink, generatePlanCategory } from '../../helper/utils';
import { planTypes } from '../../constant';

export default class Add extends FlowInterface {
  getCurrentParams() {
    return {
      ...this.getAddOnParams(),
      from: generatePlanCategory(planTypes.ZOOM_SCHEDULER),
    }
  }

  getLink() {
    return generateBuyLink(this.getCurrentParams());
  }

  getOptions() {
    return {
      disabled: !this.productEntryData?.currentUserHasPermission,
      buttonTitle: t('billing.product.entry_free_trial.upgrade'),
    };
  }
}
